
import AnimateOverSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-over-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";

export default class AnimateSymbolBehaviour extends AnimateOverSymbolBehaviour {

    /**
     * Same as AnimateOverBehaviour except the static is hidden during the animation
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAniamtion="win"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "win") {
        super(symbol, defaultAnimation);
    }

    public static() {
        if (this.animation) {
            this.symbol.setVisible(true);
        }

        super.static();
    }

    public highlight(): Contract<void> {
        return this.animate("_win", this.defaultAnimation);
    }

    public win(): Contract<void> {

        return this.animate("_win", this.defaultAnimation);
    }

    public cycle(): Contract<void> {

        return this.animate("_win", this.defaultAnimation);
    }

    protected animate(animSuffix: string | string[], defaultAnimation?: string, autoReset: boolean = false, loop: boolean = false) {
        this.symbol.setVisible(false);

        return new Contract<void>((resolve) => {
            super.animate(animSuffix, defaultAnimation, autoReset, loop).then(() => {
                this.symbol.setVisible(true);
                resolve(null);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour.ts